import { render, staticRenderFns } from "./ViewProducts.vue?vue&type=template&id=bb1cafbe&"
import script from "./ViewProducts.vue?vue&type=script&lang=ts&"
export * from "./ViewProducts.vue?vue&type=script&lang=ts&"
import style0 from "./ViewProducts.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports